import { BACK_STEP_CLICK, NEXT_STEP_CLICK, TOUR_SHOW, TOUR_SHOWN } from "../../metricsAction";

import { Data, Step, TourContext } from "./TourTypes";

export function sendMetric(context: TourContext, data: Data, index: number): void {
    if (!context.track) {
        return;
    }

    const prevIndex: undefined | number = data.get("prevIndex");

    data.set("prevIndex", index);

    if (prevIndex == undefined) {
        return;
    }

    const currentEvent = prevIndex < index ? NEXT_STEP_CLICK : BACK_STEP_CLICK;

    context.track(currentEvent, {});
}

export function sendOnShowMetric(context: TourContext, steps: Step[]): void {
    if (context.track) {
        const ids = steps.map(step => step.id);
        context.track(TOUR_SHOW, { steps: ids });
    }
}

export function sendOnShownMetric(context: TourContext): void {
    if (context.track) {
        context.track(TOUR_SHOWN, {});
    }
}
